import {ACTIVE, BLOCKED, ENI, ESSO, EXPIRED, IP, Q8, SUSPENDED} from "./FuelsConstants";
import {useTranslation} from "react-i18next";


export const useRegistryFuelCardProviders = () => {

    const {t} = useTranslation(['finance'], {keyPrefix: 'registryFuelCard.filters.providers'});


    const getRegistryFuelCardProviders = (providers: string) => {
        switch (providers) {

            case ENI:  return t('ENI');
            case IP:   return t('IP');
            case ESSO: return t('ESSO');
            case Q8:   return t('Q8');

            default : return '-'
        }
    };

    const providers = [
        {
            value: ENI,
            label: getRegistryFuelCardProviders(ENI)
        },
        {
            value: IP,
            label: getRegistryFuelCardProviders( IP)
        },
        {
            value: ESSO,
            label: getRegistryFuelCardProviders( ESSO)
        },
        {
            value: Q8,
            label: getRegistryFuelCardProviders(Q8)
        }
    ];

    return {
        providers, getRegistryFuelCardProviders
    }
}